import script from "./boardDetailPage.vue?vue&type=script&setup=true&lang=js"
export * from "./boardDetailPage.vue?vue&type=script&setup=true&lang=js"

import "./boardDetailPage.vue?vue&type=style&index=0&id=edf26e68&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-edf26e68"]])

export default __exports__